import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AppContextServiceService } from '../services/app-context-service.service';

import { firstValueFrom, filter } from 'rxjs';
import { SettingsServiceService } from '../services/settings-service.service';

export const unitResolver: ResolveFn<Promise<boolean>> = async (route, state) => {
  const appContextService = inject(AppContextServiceService);
  const settingsService = inject(SettingsServiceService);
  const router = inject(Router);

  // Wait until userUnits is not undefined or null (use observable for reactivity)
  const units = await firstValueFrom(
    appContextService.userUnits$.pipe(
      filter(units => units !== undefined && units !== null)
    )
  );

  if (!units?.length) {
    console.warn("[unitResolver] No units found for this user. Redirecting to /units...");
    await router.navigate(['/units']);
    return false;
  }

  const routeName = route.params['routename'];
  const matchedUnit = units?.find(u => u.routeName === routeName);

  if (matchedUnit) {
    appContextService.selectedUnit = matchedUnit.routeName;
    appContextService.clientName = matchedUnit.info.name;
    await appContextService.resolveClientDisplayTimeZone(matchedUnit.routeName);
    try {
      await settingsService.init(); 
    } catch (error) {
      console.error('Error in reslovver  INit()',error)
    }
    return true;
  } else {
    console.warn("[unitResolver] No unit matched! Redirecting to /units...");
    await router.navigate(['/units']);
    return false;
  }
};
